import { Form, notification, Spin, Typography, Card } from 'antd';
import { ManagePasswordForm } from './ManagePasswordForm';
import { useMutation } from '@tanstack/react-query';
import { updatePassword } from '@/api/user';
import { LoadingOutlined, LockOutlined, KeyOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { OverViewCardForm } from '@/pages/ReceptionistDashboard/Overview/Cards/OverviewCardForm';

const { Title, Text } = Typography;

const ManagePassword = () => {
	const [form] = Form.useForm();

	const mutation = useMutation({
		mutationKey: ['update-password'],
		mutationFn: updatePassword,
		onError: (data) => {
			form.setFields([
				{
					name: 'oldPassword',
					errors: [data.message],
				},
			]);
		},
		onSuccess: () => {
			notification.success({
				message: 'Success',
				description: 'Password has been updated successfully!',
				icon: <CheckCircleOutlined className="text-green-500" />,
			});
			form.resetFields();
		},
	});

	const handleSubmit = (values: { oldPassword: string; newPassword: string }) => {
		mutation.mutate(values);
	};

	return (
		<div className="p-8 max-w-5xl mx-auto">
			<div className="mb-8">
				<div className="flex items-center justify-between">
					<div className="flex items-center">
						<div className="bg-blue-50 p-3 rounded-lg mr-4">
							<LockOutlined className="text-2xl text-blue-500" />
						</div>
						<div>
							<Title level={2} className="!mb-0">
								Change Password
							</Title>
							<Text type="secondary">Update your account password to keep your account secure</Text>
						</div>
					</div>
				</div>
			</div>

			<Spin
				spinning={mutation.isPending}
				indicator={<LoadingOutlined style={{ fontSize: '48px' }} spin />}
			>
				<div className="space-y-6">
					<Card
						className="shadow-sm hover:shadow-md transition-all duration-300"
						title={
							<div className="flex items-center">
								<KeyOutlined className="text-green-500 mr-2" />
								<span>Update Password</span>
							</div>
						}
					>
						<OverViewCardForm
							isFieldTouchReset={true}
							handleSubmit={handleSubmit}
							isFormLoading={mutation.isPending}
							form={form}
							formItems={<ManagePasswordForm />}
							initialValues={{ undefined }}
						/>
					</Card>
				</div>
			</Spin>
		</div>
	);
};

export default ManagePassword;
